import React from "react";

class CircularProgress extends React.Component {

    state = {

    }



    render() {
        let progress = this.props.progress ?? 0
        let strokeWidth = this.props.strokeWidth ?? 4
        let size = this.props.size ?? 50
        let radius = (size - strokeWidth) / 2
        let circumference = radius * Math.PI * 2
        let dash = (progress * circumference) / 100


        // console.log(progress)
        return (


            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle fill="none" stroke="#ccc" cx={size / 2} cy={size / 2} r={radius} strokeWidth={`${strokeWidth}px`} />

                <circle fill="none" stroke="#fff" cx={size / 2} cy={size / 2} r={radius} strokeWidth={`${strokeWidth}px`} transform={`rotate(-90 ${size / 2} ${size / 2})`} strokeDasharray={[dash, circumference - dash]} strokeLinecap="round" style={{ transition: 'all 0.5s' }} />

                <text fill='#fff' textAnchor="middle" x={(size) / 2} y={(size + 7) / 2} style={{ width: 30, textAlign: 'center', fontSize: 9, fontWeight: '500', }}>{progress ? (((parseFloat(progress)).toFixed(0)) + '%') : ''}</text>
            </svg>




        )
    }

}


export default CircularProgress
